import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'
import { normalizeInstalledIntegrations } from './normalize-installed-integrations.js'

export function getActiveStorageProvider(config: ResolvedBetterstartConfig) {
  return normalizeInstalledIntegrations(config)
    .map((integrationId) => getIntegrationDefinition(integrationId))
    .map((definition) => definition.capabilities?.storageProvider)
    .find((provider) => provider?.provider === config.storage.provider)
}
